import Vue from 'vue'
import VueRouter from 'vue-router'
import {Message} from 'element-ui';
import Store from '@/store'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

/**
 * 自定义meta:
 *    notNeedToLogin: 不需要登录(true-是, false/null-否)
 *    title: 页面名称
 */

  const routes = [
    {
      path: '/',
      redirect: '/home',
      meta: { notNeedToLogin: true }
    },
    {
      path: '/login',
      name: "Login",
      component: () => import('@/views/Login'),
      meta: { notNeedToLogin: true }
    },
    {
      path: '/test/:courseId/:sectionId/:testId',
      name: "Test",
      component: () => import('@/views/test/Test')
    },
    {
      path: '/home',
      name: 'Home',
      redirect: '/home/page',
      component: () => import('@/views/Home'),
      meta: { notNeedToLogin: true },
      children: [
        {
          path: 'page',
          name: 'Page',
          component: () => import('@/views/homePage/Page'),
          meta: { notNeedToLogin: true, title: '首页' },
        },
        {
          path: 'information',
          name: 'Information',
          component: () => import('@/views/information/Information'),
          meta: { notNeedToLogin: true, title: '资讯' },
        },
        {
          path: 'article',
          name: 'Article',
          component: () => import('@/views/information/Article'),
          meta: { notNeedToLogin: true },
        },
        {
          path: 'mine',
          name: 'Mine',
          redirect: '/home/mine/course/All',
          component: () => import('@/views/mine/Mine'),
          children:[
            //  个人信息
            // {
            //   path: 'info',
            //   name: 'Info',
            //   component: () => import('@/views/mine/Info'),
            //   meta: { title: '个人信息' },
            // },
            //  我的课程
            {
              path: 'course/:status',
              name: 'MyCourse',
              component: () => import('@/views/mine/Course'),
              meta: { title: '我的课程' },
            },
            //  实名认证
            // {
            //   path: 'certification',
            //   name: 'Certification',
            //   component: () => import('@/views/mine/Certification'),
            //   meta: { title: '实名认证' },
            // },
            // //  我的证书
            // {
            //   path: 'credentials',
            //   name: 'Credentials',
            //   component: () => import('@/views/mine/Credentials'),
            //   meta: { title: '我的证书' },
            // },
            // //  绑定手机
            // {
            //   path: 'bindingTel',
            //   name: 'BindingTel',
            //   component: () => import('@/views/mine/BindingTel'),
            //   meta: { title: '绑定手机' },
            // },
            // //  修改密码
            // {
            //   path: 'updatePassword',
            //   name: 'UpdatePassword',
            //   component: () => import('@/views/mine/UpdatePassword'),
            //   meta: { title: '修改密码' },
            // }
          ]
        },
        // 技术人员培训学习
        {
          path: 'trainList',
          name: "TrainList",
          component: () => import('@/views/onLineTrain/List'),
          meta: { notNeedToLogin: true, title: '技术人员培训学习' },
        },
        {
          path: 'trainDetail/:courseId',
          name: "TrainDetail",
          component: () => import('@/views/onLineTrain/Detail'),
          meta: { notNeedToLogin: true },
        },
        {
          path: 'trainVideo/:courseId/:sectionId',
          name: "TrainVideo",
          component: () => import('@/views/onLineTrain/Video'),
          meta: { notNeedToLogin: true },
        },
        {
          path: 'trainDoc/:courseId/:sectionId',
          name: "TrainDoc",
          component: () => import('@/views/onLineTrain/Document'),
        },
        // 技术人员宣贯学习
        {
          path: 'eduList',
          name: "EduList",
          component: () => import('@/views/continueEdu/List'),
          meta: { notNeedToLogin: true, title: '技术人员宣贯学习' },
        },
        {
          path: 'eduDetail/:courseId',
          name: "EduDetail",
          component: () => import('@/views/continueEdu/Detail'),
          meta: { notNeedToLogin: true },
        },
        {
          path: 'eduVideoTest/:courseId/:sectionId',
          name: "EduVideoTest",
          component: () => import('@/views/continueEdu/VideoTest'),
          meta: { notNeedToLogin: true, title: '摄像头测试' },
        },
        {
          path: 'eduVideo/:courseId/:sectionId',
          name: "EduVideo",
          component: () => import('@/views/continueEdu/Video'),
          meta: { notNeedToLogin: true },
        },
        {
          path: 'eduDoc/:courseId/:sectionId',
          name: "EduDoc",
          component: () => import('@/views/continueEdu/Document')
        },
        // 讲师介绍
        {
          path: 'teacherList',
          name: "TeacherList",
          component: () => import('@/views/teacher/List'),
          meta: { notNeedToLogin: true, title: '讲师介绍' },
        },
        {
          path: 'teacherDetail/:teacherId',
          name: "TeacherDetail",
          component: () => import('@/views/teacher/Detail'),
          meta: { notNeedToLogin: true },
        },
        // 订单
        {
          path: 'orderConfirm/:courseId',
          name: "OrderConfirm",
          component: () => import('@/views/order/Confirm'),
          meta: { title: '提交订单' },
        },
        {
          path: 'orderPay/:courseId/:orderId',
          name: "OrderPay",
          component: () => import('@/views/order/OrderPay'),
          meta: { title: '支付中心' },
        },
        // 我的订单
        {
          path: 'myOrder',
          name: "MyOrder",
          component: () => import('@/views/order/MyOrder'),
          meta: { title: '我的订单' },
        },
        // 帮助中心
        {
          path: 'help',
          name: "Help",
          component: () => import('@/views/help/Help'),
          meta: { notNeedToLogin: true, title: '帮助中心' },
        },
      ]
    },
    {
      path: '*',
      redirect: '/',
    }
  ];

const isProduction = process.env.NODE_ENV === 'production';
const router = new VueRouter({
  mode: isProduction ? 'history' : 'hash',
  //设置路由跳转时，页面置顶
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes
});

/**
 * 验证是否需要登录
 */
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title + ' - 检测鉴定人员技术培训在线学习系统';
  }
  if (to.matched.some(m => !m.meta.notNeedToLogin)){
    //需要登录
    const userInfo = Store.state.userInfo;
    if (userInfo) {
      next();
    } else {
      Message.error({ showClose: true, message: '抱歉,您还未登录 !' });
      Store.commit('loginOut');
    }
  } else {
    //不需要登录
    next();
  }
});

export default router
